<sim-basic-material-dialog
	(closeClicked)="close({action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-question'}"
	[headerText]="data.title | translate"
	class="normalDuotoneHeaderIcon"
>
	<div dialogContent>
		<div class="bottom">
			<div class="text mat-h2 nomargin" [innerHtml]="data.description | translate"></div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[color]="'warn'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="data.cancelText.toUpperCase()"
		/>

		<sim-button
			(onClick)="close({action: 'ok'})"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText.toUpperCase()"
		/>
	</ng-container>
</sim-basic-material-dialog>
